// extracted by mini-css-extract-plugin
export default {"headerMenu":"headerMenu___Ew4vH","headerMenu_label":"headerMenu_label___bLKpw","headerMenu_patient":"headerMenu_patient___pPdqz"};